<template>
  <div class="app scrollbar">
    <Spin size="large" fix v-show="pageLoading"></Spin>
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="88" label-position="left" inline>
          <Row :gutter="16">
            <Col span="4">
            <FormItem label="承接厂商:" style="width: 100%">
              <Input v-model="query.SupplierName" placeholder="请输入承接厂商"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="项目名称:" style="width: 100%">
              <Input v-model="query.ProjectName" placeholder="请输入项目名称"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="物料材质:" style="width: 100%">
              <Input v-model="query.Material" placeholder="请输入物料材质"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="订单号:" style="width: 100%">
              <Input v-model="query.OrderNumber" placeholder="请输入订单号"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="全名:" style="width: 100%">
              <Input v-model="query.FulName" placeholder="请输入全名"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="图号:" style="width: 100%">
              <Input v-model="query.DrawingNo" placeholder="请输入图号"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="负责人:" :label-width="80" style="width: 100%">
              <Input v-model="query.CGBUserName" placeholder="请输入负责人"></Input>
            </FormItem>
            </Col>

            <Col span="4">
            <FormItem label="金额范围:" style="width: 100%">
              <Input v-model="query.AmountMin" placeholder="请输入最小金额值"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="-" :label-width="20" style="width: 80%">
              <Input v-model="query.AmountMax" placeholder="请输入最大金额值"></Input>
            </FormItem>
            </Col>
            <Button icon="ios-search" type="primary" size="default" @click="getInit" class="toolbar-btn">查询</Button>
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
            <Button type="primary" size="default" style="margin-left: 10px" @click="isShowSaveExcel = true">保存</Button>
          </Row>
        </Form>
      </div>
      <div class="middle">
        <div v-if="msg.length > 0" class="errortip">
          错误信息：
          <span v-for="item in msg" :key="item.row" class="message">{{ item.message + ' ' }}</span>
        </div>
        <div class="sum">金额合计:{{ totalSum }}</div>
      </div>
    </Card>
    <template>
      <div>
        <!-- <div id="luckysheet" style="position: absolute; margin: 0px; padding: 0px; width: 97%; height: 560px; z-index: 10000"></div> -->
        <div id="luckysheet" class="luckysheet-content"></div>
      </div>
    </template>
    <div class="header">

    </div>
    <Modal v-model="isShowSaveExcel" :mask-closable="false" class="modal-cont">
      <p class="content">确认保存吗？</p>
      <div slot="footer" class="footer">
        <Button @click="isShowSaveExcel = false">取消</Button>
        <Button type="primary" @click="saveEdit">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { formaterData, formaterSendData } from '../../lib/formaterData'
import ajax from '../../lib/ajax'
export default {
  name: 'edit',
  data() {
    return {
      query: {
        SupplierName: '',
        ProjectName: '',
        FulName: '',
        DrawingNo: '',
        OrderNumber: '',
        AmountMin: '',
        AmountMax: '',
        Material: '',
        Status: 5,
        IncludeBOMImportRecord: true,
        IncludeSupplier: true,
        IncludeCGBUser: true,
        Query_未到厂: true,
        SkipCount: 0,
        MaxResultCount: 100000,
        CGBUserName: '',
      },
      celldata: [],
      totalSum: 0,
      options: {
        container: 'luckysheet',
        title: '', // 表头名
        lang: 'zh', // 中文
        showtoolbar: false, // 是否显示工具栏
        showinfobar: false, // 是否显示顶部信息栏
        showsheetbar: false, // 是否显示底部sheet按钮
        sheetFormulaBar: false,
        showstatisticBar: false,
        showstatisticBarConfig: {
          count: false, // 计数栏
          view: false, // 打印视图
          zoom: false, // 缩放
        },
        row: 1,
        column: 1,
        defaultColWidth: 100,
        defaultRowHeight: 20,
        // columnHeaderHeight:100,
        rowHeaderWidth: 0,
        enableAddRow: false,
        enableAddBackTop: false,
        hook: {
          cellEditBefore: function (range) {
            // console.log(range[0].row_focus);
            // 一行高亮显示
            luckysheet.setRangeShow([`A${range[0].row_focus + 1}:AC${range[0].row_focus + 1}`])
          },
          cellUpdateBefore: function (r, c, value, isRefresh) {
            if (r === 0) {
              return false
            }
            if (c === 0) {
              return false
            }
            if (c == 5) {
              // if (isNaN(value)) {
              //     return false;
              // }
            }
            if (c == 6) {
              // if (isNaN(value)) {
              //     return false;
              // }
            }
            if (c == 7) {
              // if (isNaN(value)) {
              //     return false;
              // }
            }
            if (c == 8) {
              // if (isNaN(value)) {
              //     return false;
              // }
            }
            if (c === 29) {
              return false
            }
          },
          cellUpdated: async function (r, c, oldValue, newValue, isRefresh) {
            if (r === 0) {
              return false
            }
            if (c === 0) {
              return false
            }
            if (c === 29) {
              return false
            }
            if (c === 25) {
              await ajax
                .post(
                  `/api/services/app/BOMImportRecord/CalculateDelayDays?startTime=${
                    newValue.m ? newValue.m : ''
                  }&endTime=${luckysheet.getCellValue(r, 26) ? luckysheet.getCellValue(r, 26) : ''}`
                )
                .then((res) => {
                  luckysheet.setCellValue(r, 27, {
                    v: res.data.result,
                    fc: res.data.result > 0 ? '#ff1f1d' : '#438b3f',
                  })
                  // luckysheet.setCellValue(r, 27, res.data.result)
                })
            }
            if (c === 26) {
              ajax
                .post(
                  `/api/services/app/BOMImportRecord/CalculateDelayDays?startTime=${
                    luckysheet.getCellValue(r, 25) ? luckysheet.getCellValue(r, 25) : ''
                  }&endTime=${newValue.m ? newValue.m : ''}`
                )
                .then((res) => {
                  luckysheet.setCellValue(r, 27, {
                    v: res.data.result,
                    fc: res.data.result > 0 ? '#ff1f1d' : '#438b3f',
                  })
                  //   luckysheet.setCellValue(r, 27, res.data.result);
                })
            }
          },
          // cellRenderBefore:function(cell,any){
          //   if (any.c === 0) {
          //     return false
          //   }
          //   if (any.c === 0) {
          //     return false
          //   }
          //   if (any.c === 29) {
          //     return false
          //   }
          //   console.log('执行方法!');
          // },
          // rangeMoveAfter:function (oldRange, newRange){
          //   console.log('执行方法!');
          // },
          // rangePasteAfter:function(range,orginData,pasteData){
          //   console.log('执行方法!');
          // },
          // rangePullAfter:function(range){
          //   console.log('执行方法!');
          // },
          // rangeMoveBefore:function (oldRange, newRange){
          //   console.log('执行方法!');
          // },
          // rangePasteBefore:function(range,orginData,pasteData){
          //   console.log('执行方法!');
          // },
          // rangePullBefore:function(range){
          //   console.log('执行方法!');
          // },
          rangeSelect: function (sheet, range) {
            //console.log(range);
            var row = range[0].row
            //console.log(row);
            //console.log(row[0]);
            for (var r = row[0]; r <= row[1]; r++)
              //console.log(luckysheet.getCellValue(r,31));
              if (luckysheet.getCellValue(r, 31) == false) luckysheet.setCellValue(r, 31, true)
          },
        },
        cellRightClickConfig: {
          copy: false, // 复制
          copyAs: false, // 复制为
          paste: false, // 粘贴
          insertRow: false, // 插入行
          insertColumn: false, // 插入列
          deleteRow: false, // 删除选中行
          deleteColumn: false, // 删除选中列
          deleteCell: false, // 删除单元格
          hideRow: false, // 隐藏选中行和显示选中行
          hideColumn: false, // 隐藏选中列和显示选中列
          rowHeight: false, // 行高
          columnWidth: false, // 列宽
          clear: false, // 清除内容
          matrix: false, // 矩阵操作选区
          sort: false, // 排序选区
          filter: false, // 筛选选区
          chart: false, // 图表生成
          image: false, // 插入图片
          link: false, // 插入链接
          data: false, // 数据验证
          cellFormat: false, // 设置单元格格式
        },
      },
      isShowSaveExcel: false,
      msg: [],
      /** 页面内加载遮罩（不用 $Spin，避免全局遮罩在 keep-alive 切换后仍盖住其它页） */
      pageLoading: false,
      // isShowExcel: false,
    }
  },

  mounted() {
    this.getCurrentUser()
  },
  activated() {
    // 判断是否取消过
    if (this.$store.state.purchase.cancel) {
      // this.getInit()
      this.getCurrentUser()
      this.$store.dispatch({ type: 'purchase/setCancelData', data: false })
    }
  },
  /** keep-alive 下若在加载中离开，重置本地遮罩，避免返回本页仍显示加载中 */
  deactivated() {
    this.pageLoading = false
  },
  methods: {
    async getInit() {
      if (this.query.SupplierName.length > -1) {
        // this.isShowExcel = true;
        this.msg = []
        this.pageLoading = true
        let result = []
        try {
          const res = await this.$Ajax.get('/api/services/app/GZBDataItem/QueryDto', {
            params: this.query,
          })
          console.log(res)
          result = res.data.result.items
          this.totalSum = res.data.result.amountSum
          this.celldata = formaterData(result)
          const data = [
            {
              name: '管制表',
              index: 1,
              status: 1,
              order: 0,
              celldata: this.celldata,
              config: {
                colhidden: {
                  // '0':0
                  1: 0,
                  30: 0,
                  31: 0,
                },
                columnlen: {
                  0: 40,
                  1: 0,
                  2: 150,
                  3: 115,
                  4: 250,
                  5: 95,
                  6: 57,
                  7: 57,
                  8: 57,
                  9: 57,
                  10: 140,
                  11: 60,
                  12: 60,
                  13: 60,
                  14: 60,
                  15: 55,
                  16: 65,
                  17: 100,
                  18: 65,
                  19: 70,
                  20: 80,
                  21: 80,
                  22: 80,
                  23: 80,
                  24: 80,
                  25: 100,
                  26: 100,
                  27: 100,
                  28: 60,
                  29: 60,
                  30: 0,
                  31: 0,
                },
                rowlen: {}, //行高
              },
              frozen: {
                type: 'both',
              },
              showGridLines: 1,
            },
          ]
          this.options.data = data
          window.luckysheet.create(this.options)
          //所属
          luckysheet.setDataVerification(
            {
              type: 'dropdown',
              type2: null,
              value1: '采购,外协',
              prohibitInput: true,
            },
            {
              range: 'S2:S4000',
            }
          )
          //类别1
          luckysheet.setDataVerification(
            {
              type: 'dropdown',
              type2: null,
              value1: '低值易耗,标准件,主材料,加工件,数控加工,五金工具,表面处理',
              prohibitInput: true,
            },
            {
              range: 'T2:T4000',
            }
          )
          //模具类型
          luckysheet.setDataVerification(
            {
              type: 'dropdown',
              type2: null,
              value1: '门吸,门发,门冲,箱吸,箱发,箱冲,无',
              prohibitInput: true,
            },
            {
              range: 'W2:W4000',
            }
          )
          //产线
          luckysheet.setDataVerification(
            {
              type: 'dropdown',
              type2: null,
              value1: 'PDCPD,焊接结构件,幻音产品,摩泰克,冷模,热模,非标加工件,轮胎模具,汽车座椅模具,PDCPD制品,PDCPD模具,自动化',
              prohibitInput: true,
            },
            {
              range: 'Y2:Y4000',
            }
          )
          //设置高亮
          luckysheet.setRangeShow('B2')
        } finally {
          this.pageLoading = false
        }
      } else {
        // this.isShowExcel = false;
      }
    },
    async getCurrentUser() {
      const { data } = await this.$Ajax.post('/api/services/app/GZBDataItem/GZBDataItemQueryInitia')
      if (data.success) {
        this.query.CGBUserName = data.result.cgbUserName
      }
      this.getInit()
    },
    reset() {
      //   Object.keys(this.query).forEach((key) => (this.query[key] = ''))
      this.query = {
        SupplierName: '',
        ProjectName: '',
        FulName: '',
        DrawingNo: '',
        OrderNumber: '',
        AmountMin: '',
        AmountMax: '',
        Material: '',
        Status: 5,
        IncludeBOMImportRecord: true,
        IncludeSupplier: true,
        IncludeCGBUser: true,
        Query_未到厂: true,
        SkipCount: 0,
        MaxResultCount: 100000,
        CGBUserName: '',
      }
    },
    // 保存
    async saveEdit() {
      let _this = this
      // 保存前将驯服的数据保存
      luckysheet.exitEditMode() //页面触发双击编辑后点击其他地方触发保存
      let data = formaterSendData(window.luckysheet.getAllSheets()[0].celldata)
      let savaData = []
      this.isShowSaveExcel = false
      data.forEach(function (item) {
        if (item.isUpdate) savaData.push(item)
        if (item.isUpdate == null) {
          savaData.push(item)
        }
      })
      this.pageLoading = true
      try {
        const res = await this.$Ajax.put('/api/services/app/GZBDataItem/UpdateGzbItemData', savaData)
        if (res.data.result.success) {
          this.$Message.success({
            content: '保存成功',
          })
          this.getInit()
        } else {
          this.$Message.error({
            content: '保存失败',
          })
          this.msg = []
          // for (let i = 0; i < savaData.length; i++) {
          //   for (let n = 0; n < 32; n++) {
          //     luckysheet.setCellValue(i + 1, n, {
          //       bg: '#fff',
          //     })
          //   }
          //   for (let j = 0; j < res.data.result.resultInfoList.length; j++) {
          //     if (savaData[i].id === res.data.result.resultInfoList[j].id) {
          //       for (let k = 0; k < 32; k++) {
          //         luckysheet.setCellValue(i + 1, k, {
          //           bg: '#ff1f1d',
          //         })
          //       }
          //       let obj = {
          //         row: i + 1,
          //         message: res.data.result.resultInfoList[j].message,
          //       }
          //       this.msg.push(obj)
          //     }
          //   }
          // }
          let flag
          for (let i = 0; i < data.length; i++)
            if (data[i].id == res.data.result.resultInfoList[0].id) {
              flag = i
              let obj = {
                row: flag + 1,
                message: '第' + (flag + 1) + '行中,',
              }
              this.msg.push(obj)
              break
            }
          for (let col = 0; col < 32; col++) luckysheet.setCellValue(flag + 1, col, { bg: '#ff1f1d' })
          for (let j = 0; j < res.data.result.resultInfoList.length; j++) {
            let obj = {
              row: flag + 1,
              message: res.data.result.resultInfoList[j].message,
            }
            this.msg.push(obj)
          }
        }
      } finally {
        this.pageLoading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
// @import url('https://cdn.jsdelivr.net/npm/luckysheet/dist/plugins/css/pluginsCss.css');
// @import url('https://cdn.jsdelivr.net/npm/luckysheet/dist/plugins/plugins.css');
// @import url('https://cdn.jsdelivr.net/npm/luckysheet/dist/css/luckysheet.css');
// @import url('https://cdn.jsdelivr.net/npm/luckysheet/dist/assets/iconfont/iconfont.css');

* {
  // margin: 0;
  padding: 0;
}

.errortip {
  margin-top: -6px;

  padding-right: 200px;
}

.message {
  color: red;
}
.app {
  min-width: 1260px;
  position: relative;
}
.ivu-btn {
  margin-right: 5px;
}

.header {
  display: flex;
  height: 30px;
  width: 98%;
  line-height: 30px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 760px;
  text-align: center;
}

.luckysheet-content {
  margin: 0px;
  padding: 0px;
  position: absolute;
  width: 97%;
  height: 540px;
  left: 24px;
  top: 180px;
  bottom: 0px;
  min-width: 1260px;
}

.ivu-btn {
  width: 60px;
  height: 30px;
  line-height: 30px;
}

.printHideCss {
  visibility: hidden !important;
}
.excelContent {
  position: relative;
  width: 100%;
}

.tips {
  text-align: center;
  margin-top: 50px;
  font-size: 28px;
  color: #000;
}

// /deep/.luckysheet-modal-dialog {
//     width: 100px !important;
//     padding: 0 !important;
// }
// /deep/.luckysheet-cols-h-cells {
//     display: none !important;
// }

.content {
  text-align: center;
  font-size: 16px;
}

.footer {
  text-align: center;
}

.modal-cont /deep/ .ivu-modal-body {
  font-size: 20px;
  text-align: center;
}
.modal-cont /deep/ .ivu-modal {
  top: 300px;
}
.page-body {
  position: relative;
}

.middle {
  position: relative;
  //display:block;
  //margin-bottom:40px;
}

.sum {
  position: absolute;
  bottom: 0px;
  right: 10px;
  color: red;
}
#luckysheet {
  margin-top: 10px;
}
</style>
